import { invalidFormNameChar } from './constants';
import { FileContentType } from './file-content-type.enum';
import { FileType } from './file-type.enum';

export interface IFileReference {
  name: string;
  path: string;
  blobPath?: string | ArrayBuffer; // Required for dynamic file loading
  order: number;
  fileType: FileType;

  contentType: FileContentType;

  get baseName(): string;
  get cleanPath(): string;
  get isLocal(): boolean;
}

export function IFileRefGetBaseName(file: IFileReference): string {
  const pieces = file.name?.split('.');
  if (pieces?.length <= 1) return file.name;
  pieces.pop();
  return pieces.join('.').trim();
}

export function IFileRefGetCleanPath(file: IFileReference): string {
  return file.path.replace(invalidFormNameChar, '-');
}

export function IFileRefIsLocal(file: IFileReference): boolean {
  return (file as any)['local'] || (file.path?.startsWith('local:') ?? false);
}
